"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ensure_string_1 = require("ensure-string");
const papaparse_1 = __importDefault(require("papaparse"));
const getMoleculeCreators_1 = __importDefault(require("./getMoleculeCreators"));
const defaultCSVOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
};
async function appendCSV(moleculesDB, csv, options = {}) {
    const { onStep } = options;
    csv = (0, ensure_string_1.ensureString)(csv);
    const moleculeCreators = (0, getMoleculeCreators_1.default)(moleculesDB.OCL);
    if (typeof csv !== 'string') {
        throw new TypeError('csv must be a string');
    }
    options = { ...defaultCSVOptions, ...options };
    const parsed = papaparse_1.default.parse(csv, options);
    const fields = parsed.meta.fields;
    const stats = new Array(fields.length);
    const firstElement = parsed.data[0];
    let moleculeCreator, moleculeField;
    for (let i = 0; i < fields.length; i++) {
        stats[i] = {
            label: fields[i],
            isNumeric: typeof firstElement[fields[i]] === 'number',
        };
        const lowerField = fields[i].toLowerCase();
        if (moleculeCreators.has(lowerField)) {
            moleculeCreator = moleculeCreators.get(lowerField);
            moleculeField = fields[i];
        }
    }
    if (!moleculeCreator) {
        throw new Error('this document does not contain any molecule field');
    }
    moleculesDB.statistics = stats;
    for (let i = 0; i < parsed.data.length; i++) {
        moleculesDB.pushEntry(moleculeCreator(parsed.data[i][moleculeField]), parsed.data[i]);
        if (onStep) {
            await onStep(i + 1, parsed.data.length);
        }
    }
}
exports.default = appendCSV;
//# sourceMappingURL=appendCSV.js.map